import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Footer: React.FC = () => {
  const [isFullScreenMode, setIsFullScreenMode] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkFullScreenMode = () => {
      setIsFullScreenMode(document.body.classList.contains('full-screen-mode'));
    };

    // Check initially
    checkFullScreenMode();

    // Watch for changes to the body class
    const observer = new MutationObserver(checkFullScreenMode);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  const handleLinkClick = (linkName: string) => {
    if (linkName === 'Terms of Service') {
      navigate('/terms-of-service');
    } else if (linkName === 'Privacy Policy') {
      navigate('/privacy-policy');
    } else if (linkName === 'Refund Policy') {
      navigate('/terms-of-service#refunds');
    } else if (linkName === 'Contact Us') {
      navigate('/contact-us');
    } else {
      console.log(`${linkName} clicked`);
    }
  };

  if (isFullScreenMode) {
    return null;
  }

  return (
    <footer className="bg-surface-light dark:bg-background-card border-t border-border-light dark:border-border-color py-6 px-4 md:px-6">
      <div className="flex flex-col md:flex-row justify-between items-center gap-4 md:gap-6">
        <div className="text-sm text-text-light-secondary dark:text-text-secondary">
          © 2026 Stock Table. All rights reserved.
        </div>
        <div className="flex flex-wrap justify-center md:justify-end items-center gap-4 md:gap-6">
          <button
            onClick={() => handleLinkClick('Terms of Service')}
            className="text-sm text-text-light-secondary dark:text-text-secondary hover:text-gold-text-light dark:hover:text-highlight-gold transition-colors duration-200"
          >
            Terms of Service
          </button>
          <button
            onClick={() => handleLinkClick('Privacy Policy')}
            className="text-sm text-text-light-secondary dark:text-text-secondary hover:text-gold-text-light dark:hover:text-highlight-gold transition-colors duration-200"
          >
            Privacy Policy
          </button>
          <button
            onClick={() => handleLinkClick('Refund Policy')}
            className="text-sm text-text-light-secondary dark:text-text-secondary hover:text-gold-text-light dark:hover:text-highlight-gold transition-colors duration-200"
          >
            Refund Policy
          </button>
          <button
            onClick={() => handleLinkClick('Contact Us')}
            className="text-sm text-text-light-secondary dark:text-text-secondary hover:text-gold-text-light dark:hover:text-highlight-gold transition-colors duration-200"
          >
            Contact Us
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

